import { render, staticRenderFns } from "./ContextMenu.vue?vue&type=template&id=2dfd7634&scoped=true"
import script from "./ContextMenu.vue?vue&type=script&lang=ts"
export * from "./ContextMenu.vue?vue&type=script&lang=ts"
import style0 from "./ContextMenu.vue?vue&type=style&index=0&id=2dfd7634&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfd7634",
  null
  
)

export default component.exports